import { useEffect, useState } from "react";
import { axiosInstance } from "../../../axios";
import { useNavigate } from "react-router-dom";

function AgendaComponent({ id, audioData, agendaSocket}) {
    // Data and state definitions
    const [data, setData] = useState(null);
    const [agendaEditing, setAgendaEditing] = useState(false);
    const [informationEditing, setInformationEditing] = useState(false);
    const [isAgendaChecked, setIsAgendaChecked] = useState(audioData.agendaActive);
    const [meetinInfoUpdated, setMeetingInfoUpdated] = useState(false);
    const [agendaData, setAgendaData] = useState([]);
    const [changedAgendaItems, setChangedAgendaItems] = useState({});

    // Expand agendaData to include start and finish times for each topic
    // const [agendaData, setAgendaData] = useState({
    //     entries: Array(1).fill({ startTime: '00:00', finishTime: '00:00', topic: '회의 주제', presenter: '비고' }), // Assuming 5 agenda entries
    // });
    const navigate = useNavigate();
    const [editedAgendaData, setEditedAgendaData] = useState([]);
    const [formData, setFormData] = useState({
        title: audioData.title,
        productName: audioData.productName,
        meetingDate: audioData.meetingDate,
        meetingPlace: audioData.meetingPlace,
        purpose: audioData.purpose,
    });
    const [initialData, setInitialData] = useState({
        title: audioData.title,
        productName: audioData.productName,
        meetingDate: audioData.meetingDate,
        meetingPlace: audioData.meetingPlace,
        purpose: audioData.purpose,
    });

    // update Meeting info
    const updateMeetingInfo = async () => {
        try {
            const formDataUpdate = new FormData();
            formDataUpdate.append('title', formData.title);
            formDataUpdate.append('productName', formData.productName);
            formDataUpdate.append('meetingDate', formData.meetingDate);
            formDataUpdate.append('meetingPlace', formData.meetingPlace);
            formDataUpdate.append('purpose', formData.purpose);
            const response = await axiosInstance.patch(`solo_audio/${id}/`, formDataUpdate);
            // console.log(response?.status);
            if (response?.status === 200) {
                // console.log(response?.data);
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {

                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    };

    // use effect
    useEffect(() => {
        fetchData();
    }, []);

    // Update Agenda
    const updateAgenda = async (row_id) => {
        try {
            const formDataUpdate = new FormData();
            formDataUpdate.append('startTime', );
            formDataUpdate.append('finishTime', );
            formDataUpdate.append('presenter', );
            formDataUpdate.append('topic', );
            formDataUpdate.append('purpose', );
            const response = await axiosInstance.patch(`agenda/${id}/${row_id}/`, formDataUpdate);
            // console.log(response?.status);
            if (response?.status === 200) {
                // console.log(response?.data);
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {

                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    };

    // change checkbox request
    const checkBoxRequest = async () => {
        try {
            const response = await axiosInstance.patch(`solo_audio/${id}/`, {
                "agendaActive": !isAgendaChecked
            });
            // console.log(response?.status);
            if (response?.status === 200) {
                // console.log(response?.data);
                setIsAgendaChecked(!isAgendaChecked);
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {

                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    };

    // Remove Agenda
    const removeAgenda = async (row_id) => {
        try {
            const response = await axiosInstance.delete(`agenda/${id}/${row_id}/`);
            // console.log(response?.status);
            if (response?.status === 200) {
                // console.log(response?.data);
                // Update local state to remove the item from the list
                setEditedAgendaData(editedAgendaData.filter(item => item.id !== row_id));
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {

                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    };

    // Add agenda
    const addAgendaRequest = async () => {

        try {
            const response = await axiosInstance.post(`agenda/${id}/`, {
            });
            // console.log(response?.status);
            if (response?.status === 201) {
                // console.log(response?.data);
                fetchData();
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {

                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    };


    // Fetch Data
    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`agenda/${id}/`);
            // console.log(response?.status);
            if (response?.status === 200) {
                // console.log(response?.data);
                setAgendaData(response.data)
                setEditedAgendaData(response.data)
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {

                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    };

    const handleAgendaCheckboxChange = () => {
        checkBoxRequest();
    };

    // Update formData and agendaData state when input changes
    const handleInputChange = (e, field, section) => {
        console.log("Handling input change for section:", section);
        if (section === "information") {
            console.log("change information")
            // setMeetingInfoUpdated(true);
            setFormData({ ...formData, [field]: e.target.value });
        } else if (section === "agenda") {
            // setAgendaData({ ...agendaData, topics: agendaData.topics.map((topic, index) => index === Number(field) ? e.target.value : topic) });
        }
    };



    // Method to handle editing
    const handleEditClick = (section) => {
        if (section === "agenda") {
            setAgendaEditing(true);
        } else if (section === "information") {
            setInformationEditing(true);
        }
    };

    // Method to handle cancel
    const handleCancel = (section) => {
        if (section === "agenda") {
            setAgendaEditing(false);
            // setAgendaData({ ...agendaData, entries: initialData.agendaEntries });
        } else if (section === "information") {
            setInformationEditing(false);
            setFormData({
                title: initialData.title,
                productName: initialData.productName,
                meetingDate: initialData.meetingDate,
                meetingPlace: initialData.meetingPlace,
                purpose: initialData.purpose
            });
        }
    };

    const postData = async () => {
        console.log(JSON.stringify({
            update: data
        }))
        try {
            const response = await axiosInstance.post(`audio_summarize/${id}/`, {
                "update": JSON.stringify(data)
            });
            // console.log(response?.status);
            if (response?.status === 200) {
                // console.log(response?.data);
                // Handle successful response, e.g., set some state.
            } else if (response?.data?.detail == 'Unauthenticated!') {

                navigate('/auth/login'); // Use navigate to redirect to the login page.
            } else {
            }
        } catch (error) {
            // TODO: handle errors
        }
    }

    const handleAgendaInputChange = (e, itemId, field) => {
        setEditedAgendaData(editedAgendaData.map(item =>
            item.id === itemId ? { ...item, [field]: e.target.value } : item
        ));
        console.log(itemId)
        setChangedAgendaItems(prevItems => ({
            ...prevItems,
            [itemId]: { ...(prevItems[itemId] || {}), [field]: e.target.value }
        }));
    };

    const saveAgendaChanges = async () => {
        setAgendaEditing(false);
        console.log("changed agenda")
        for (const [itemId, changedItem] of Object.entries(changedAgendaItems)) {
            try {
                const response = await axiosInstance.patch(`agenda/${id}/${itemId}/`, changedItem);
                console.log('Updated item:', response.data);
                
                // Handle successful response
            } catch (error) {
                console.error('Error updating item:', error);
                // Handle error for this item
            }
        }
        setChangedAgendaItems({}); // Clear the changed items after saving
    };

    // const handleAgendaInputChange = (e, index, field) => {
    //     console.log("canged")
    //     const newAgendaData = editedAgendaData.map((item, idx) => {
    //         if (item.id === index) {
    //             console.log("true is this field")
    //             console.log(item.id)
                
    //             return { ...item, [field]: e.target.value };
    //         }
    //         return item;
    //     });
    //     setEditedAgendaData(newAgendaData);
    // };

    // Save changes agenda
    // const saveAgendaChanges = async () => {
    //     for () {
    //         if (item.id < 0) {
    //             // Send POST request to add new item
    //         } else {
    //             try {
    //                 // Send PATCH request to update existing item
    //                 const response = await axiosInstance.patch(`agenda/${id}/${item.id}/`, { ...item });
    //                 // console.log(response?.status);
    //                 if (response?.status === 200) {
    //                     // console.log(response?.data);
    //                     // Handle successful response, e.g., set some state.
    //                 } else if (response?.data?.detail == 'Unauthenticated!') {

    //                     navigate('/auth/login'); // Use navigate to redirect to the login page.
    //                 } else {
    //                 }
    //             } catch (error) {
    //                 // TODO: handle errors
    //             }
    //         }
    //     }
    //     setAgendaData(editedAgendaData); // Synchronize agendaData with the saved state
    // };

    const deleteAgendaItem = async (row_id, index) => {
        // Send delete request to the server
        await axiosInstance.delete(`agenda/${id}/${row_id}/`);
    
        // Update the local state
        const updatedAgendaData = editedAgendaData.filter(item => item.id !== id);
        setEditedAgendaData(updatedAgendaData);
    };

    // Method to handle saving
    const handleSave = async (section) => {
        // Update state and POST request logic...
        if (section === "agenda") {
            saveAgendaChanges()
            // setAgendaEditing(false);
            // setInitialData({ ...initialData, agendaEntries: agendaData.entries });
        } else if (section === "information") {
            setInformationEditing(false);
            // setInitialData({ ...initialData, ...formData });
            updateMeetingInfo()
        }
        // Update data state and POST request logic...
    };


    // Render edit buttons
    const renderEditButtons = (section) => {
        const isEditing = section === "agenda" ? agendaEditing : informationEditing;

        if (isEditing) {
            return (
                <>
                    {isEditing == agendaEditing && <a  className="text-warning text-decoration-none" onClick={() => addAgendaRequest()} style={{ marginRight: 15 }}>
                        <i className="fa fa-fw fa-plus"></i>
                    </a>}

                    <a onClick={() => handleSave(section)} className="text-success text-decoration-none" style={{ marginRight: 15 }}>
                        <i className="fa fa-fw fa-save"></i>
                    </a>
                    <a onClick={() => handleCancel(section)} className="text-danger text-decoration-none">
                        <i className="fa fa-fw fa-close"></i>
                    </a>
                </>
            );
        } else {
            return (
                <a onClick={() => handleEditClick(section)} className="text-body text-opacity-50 text-decoration-none">
                    <i className="fa fa-fw fa-edit"></i>
                </a>
            );
        }
    };



    return (<>
        {/* Information */}
        <div className="card shadow" style={{ marginBottom: 15 }}>
            <div class="card-header d-flex align-items-center bg-none">
                <span class="flex-grow-1 fw-bold">1) 회의록 개요</span>
                <div className="text-body text-opacity-50 text-decoration-none">
                    {renderEditButtons("information")}
                </div>
            </div>
            <div className="card-body">
                <table class="table">
                    <tbody style={{ verticalAlign: 'middle' }}>
                        <tr>
                            <td className="text-end">제목:</td>
                            <td>
                                <input
                                    type="text"
                                    class={`${informationEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                    id="title"
                                    value={formData.title}
                                    onChange={(e) => handleInputChange(e, "title", "information")}
                                    readOnly={!informationEditing}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="text-end">제품명:</td>
                            <td> <input
                                type="text"
                                class={` ${informationEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                id="title"
                                value={formData.productName}
                                onChange={(e) => handleInputChange(e, "productName", "information")}
                                readOnly={!informationEditing}
                            /></td>
                        </tr>
                        <tr>
                            <td className="text-end">회의 일시:</td>
                            <td> <input
                                type="text"
                                class={`${informationEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                id="title"
                                value={formData.meetingDate}
                                onChange={(e) => handleInputChange(e, "meetingDate", "information")}
                                readOnly={!informationEditing}
                            /></td>
                        </tr>
                        <tr>
                            <td className="text-end">회의 장소:</td>
                            <td> <input
                                type="text"
                                class={`${informationEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                id="title"
                                value={formData.meetingPlace}
                                onChange={(e) => handleInputChange(e, "meetingPlace", "information")}
                                readOnly={!informationEditing}
                            /></td>
                        </tr>
                        <tr>
                            <td style={{ width: '25%' }} className="text-end">목적과 취지:</td>
                            <td> <input
                                type="text"
                                class={`${informationEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                id="title"
                                value={formData.purpose}
                                onChange={(e) => handleInputChange(e, "purpose", "information")}
                                readOnly={!informationEditing}
                            /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="text-muted small"><span class="text-danger">*</span>Agenda 작성이 필요할시 체크박스를 클릭하고 텍스트를 입력해주세요.</div>
        <div className="card shadow" style={{ marginBottom: 15 }}>
            <div class="card-header d-flex align-items-center bg-none">
                <span class="flex-grow-1 fw-bold">
                    <input type="checkbox" class="form-check-input" checked={isAgendaChecked}
                        onChange={handleAgendaCheckboxChange} />
                    {' '}2) 목차<span class="text-danger">*</span></span>
                <div className="text-body text-opacity-50 text-decoration-none">
                    {isAgendaChecked && renderEditButtons("agenda")}
                </div>
            </div>
            <div className="card-body">
            {/* Agenda checkbox */}
            {isAgendaChecked && (<>
                
                <table class="table">
                    <tbody className='text-center'>
                        {editedAgendaData.map((entry, index) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="text"
                                        class={`text-center ${agendaEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                        value={entry.startTime}
                                        onChange={(e) => handleAgendaInputChange(e, entry.id, "startTime")}
                                        readOnly={!agendaEditing}
                                    />
                                </td>
                                <td className="align-middle">~</td>
                                <td>
                                    <input
                                        type="text"
                                        class={`text-center ${agendaEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                        value={entry.finishTime}
                                        onChange={(e) => handleAgendaInputChange(e, entry.id, "finishTime")}
                                        readOnly={!agendaEditing}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        class={`text-center ${agendaEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                        value={entry.topic}
                                        onChange={(e) => handleAgendaInputChange(e, entry.id, "topic")}
                                        readOnly={!agendaEditing}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        class={`text-center ${agendaEditing ? "form-control" : "form-control-plaintext readonly"}`}
                                        value={entry.presenter}
                                        onChange={(e) => handleAgendaInputChange(e, entry.id, "presenter")}
                                        readOnly={!agendaEditing}
                                    />
                                </td>
                                {agendaEditing && (

                                    <span class="text-danger fa fa-fw fa-remove" onClick={() => removeAgenda(entry.id, index)}></span>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            
            </>)}
            </div>
        </div>
    </>)
}

export default AgendaComponent;